import angular from 'angular';
import moment from 'moment';
import { IAnalisePonto } from './../../models/analiseponto.model';
import { IApuracaoFilter, IApuracaoPonto, IApuracaoSelectItem } from '../../models/apuracaoponto.model';
import { AnalisesPontoService } from '../analisesponto.service';
import { ApuracoesPontoService } from '../../ApuracoesPonto/apuracoesponto.service';
import { applyNsjTableInlineMobileLabels } from '../../../../../utils/nsj-table';

type IAnalisesPontoFilters = {
	apuracao: IApuracaoFilter | null;
	lotacao: { lotacao: string } | null;
	departamento: { departamento: string } | null;
	grupo: { grupo: string } | null;
	trabalhador: { trabalhador: string } | null;
	situacaoColaborador: string | null;
};

export class AnalisesPontoIndexController {

    static $inject = [
		'$rootScope',
		'$scope',
		'$state',
		'$stateParams',
		'AnalisesPontoService',
		'ApuracoesPontoService',
		'toaster',
		'NewToaster'
	];

    // initial state
    public entities: Array<IAnalisePonto> = [];
    public busy: boolean = false;
    public apuracoes: Array<IApuracaoPonto> = [];
	public apuracoesSelect: IApuracaoSelectItem[] = [];
	public filters: IAnalisesPontoFilters = {
		apuracao: null,
		lotacao: null,
		departamento: null,
		grupo: null,
		trabalhador: null,
		situacaoColaborador: '00',
	};
    public filtersParams = {
        empresa: '',
        estabelecimento: ''
    };
	public filterActive: boolean = false;

    // table
	public carregouTudo: boolean = false;
	public checkboxPreenchidos: Array<IAnalisePonto> = [];
	public checkToggle: any = {};
	public fields = applyNsjTableInlineMobileLabels([
		{
			value: 'codigo',
			label: 'Matrícula',
			type: 'string',
			style: 'title',
			copy: '',
		},
		{
			value: 'nome',
			label: 'Colaborador',
			type: 'string',
			style: 'title',
			copy: '',
		},
		{
			value: 'departamento_nome',
			label: 'Departamento',
			type: 'string',
			style: 'title',
			copy: '',
		},
		{
			value: 'totalextra',
			label: 'Horas Extras',
			type: 'string',
			style: 'title',
			copy: '',
		},
		{
			value: 'totalatrasos',
			label: 'Atrasos',
			type: 'string',
			style: 'title',
			copy: '',
		},
		{
			value: 'totaladicional',
			label: 'Adicional Noturno',
			type: 'string',
			style: 'title',
			copy: '',
		},
		{
			value: 'totalfaltas',
			label: 'Faltas',
			type: 'string',
			style: 'title',
			copy: '',
		},
		{
			value: 'urlponto',
			label: 'Ações',
			type: 'string',
			style: 'title',
			copy: '',
            customCollumnHtml: () => {
                let someHtmlVar = `
                <a
					class="btn btn-sm"
					href="{{tableRowEntity.urlponto}}"
					target="_blank"
				>
					<i
						class="fa fa-external-link-alt"
						aria-hidden="true"
						uib-tooltip="Ponto"
						tooltip-placement="top"
					></i>
				</a>
              `;
                return someHtmlVar;
            },
		},
	]);

    constructor (
        public $rootScope: angular.IRootScopeService & {
			liberadoTela: (arg: string) => boolean,
			temPermissao: (arg: string) => boolean,
			session: any,
			nsjGlobals: any
		},
        public $scope: angular.IScope,
		public $state: angular.ui.IStateService,
        public $stateParams: angular.ui.IStateParamsService,
        public AnalisesPontoService: AnalisesPontoService,
        public ApuracoesPontoService: ApuracoesPontoService,
		public toaster: any,
        public NewToaster: { pop: Function },
	) {
		if (
			!this.$rootScope.temPermissao('visualizar_analise') ||
			!this.$rootScope.liberadoTela('LIBERAR_ANALISES_PONTO')
		) {
            $state.go('dp');
        }

        this.busy = true;
		this.carregaApuracoes();

        $scope.$on('apuracoesponto_index_loaded', () => {
			if (this.ApuracoesPontoService.loadParams.finished ||
                this.ApuracoesPontoService.loadParams.to_load === 0
            ) {
                this.montaApuracaoSelect();
            }
        });

        $scope.$on('relatorioanalise_relatorioanalise_loaded', (event, args: any) => {
			this.entities = angular.copy(args);
			this.carregouTudo = true;
            this.busy = false;
        });

        $scope.$on('relatorioanalise_relatorioanaliseexportacao_sucesso', (event, args: any) => {
			this.trataDownload(args.data);
			this.busy = false;
        });

        $scope.$on('relatorioanalise_relatorioanaliseexportacao_erro', () => {
			this.busy = false;
        });
    }

	carregaApuracoes() {
		this.busy = true;
		this.ApuracoesPontoService.constructors['vigente'] = false;
		this.ApuracoesPontoService.constructors['empresa'] = this.$rootScope.session.entities.empresa.empresa;
		this.ApuracoesPontoService.constructors['estabelecimento'] = '';
		this.apuracoes = this.ApuracoesPontoService.reload();
	}

	montaApuracaoSelect(): void {
		this.apuracoesSelect = this.apuracoes.map((element) => {
			const { nome: nomeReferencia, referencia } = this.getReferenciaApuracao(element);
			return {
				periodo: `
                    ${moment(element.inicioapuracao).format('DD/MM/YYYY')} a
                    ${moment(element.terminoapuracao).format('DD/MM/YYYY')} ${nomeReferencia}`,
				inicioapuracao: element.inicioapuracao,
				terminoapuracao: element.terminoapuracao,
				apuracaoponto: element.apuracaoponto,
                referencia
			};
		});
        this.setFilterApuracao();
        this.filterApuracao();
	}

    getReferenciaApuracao(apuracao: IApuracaoPonto) {
		if (apuracao.trabalhadorobj?.trabalhador) {
            return {
                nome: `- Trabalhador: ${apuracao.trabalhadorobj.nome}`,
                referencia: apuracao.trabalhadorobj
            };
        }
        if (apuracao.lotacaoobj?.lotacao) {
            return {
                nome: `- Lotação: ${apuracao.lotacaoobj.nome} `,
                referencia: apuracao.lotacaoobj
            };
        }
        if (apuracao.estabelecimentoobj?.estabelecimento) {
            return {
                nome: `- Estabelecimento: ${apuracao.estabelecimentoobj.nomefantasia}`,
                referencia: apuracao.estabelecimentoobj
            };
        }
        if (apuracao.empresaobj?.empresa) {
            return {
                nome: `- Empresa: ${apuracao.empresaobj.razaosocial}`,
                referencia: apuracao.empresaobj
            };
        }
        return {
            nome: '',
            referencia: null
        };
    }

    setFilterApuracao() {
        if (!this.apuracoesSelect.length) {
            return;
        }

        const hasApuracaoParam = this.valorExiste(this.$stateParams.apuracaoponto);
        if (hasApuracaoParam) {
            const apuracao = this.apuracoesSelect.find(elem => elem.apuracaoponto === this.$stateParams.apuracaoponto);
            this.filters.apuracao = apuracao ?? {
                apuracaoponto: this.$stateParams.apuracaoponto,
                referencia: null
            };
            return;
        }

		const dataAtual = moment();
        const apuracaoAtual = this.apuracoesSelect.find(apuracao => {
            const inicioApuracao = moment(apuracao.inicioapuracao, 'YYYY-MM-DD');
            const terminoApuracao = moment(apuracao.terminoapuracao, 'YYYY-MM-DD');
            return dataAtual.isBetween(inicioApuracao, terminoApuracao, undefined, '[]')
                && apuracao.referencia && ('empresa' in apuracao.referencia);
        });

        if (apuracaoAtual) {
            this.filters.apuracao = apuracaoAtual;
            return;
        }
        this.filters.apuracao = this.apuracoesSelect[0];
	}

    filterApuracao() {
        const apuracao = this.filters.apuracao;
        if (!apuracao) {
            this.busy = false;
            return;
        }

        const filtersToReset = ['grupo', 'lotacao', 'departamento', 'trabalhador'];
        filtersToReset.forEach(key => this.filters[key] = null);

        let empresa = this.$rootScope.session.entities.empresa.empresa;
        let estabelecimento = '';

        const referencia = apuracao.referencia;
        if (!referencia) {
            this.refreshFilters(empresa, estabelecimento);
            this.filterReload();
            return;
        }

        if ('empresa' in referencia) {
            empresa = referencia.empresa;
        } else if ('estabelecimento' in referencia) {
            estabelecimento = referencia.estabelecimento;
        }

        this.refreshFilters(empresa, estabelecimento);

        if ('lotacao' in referencia) {
            this.filters.lotacao = referencia;
        } else if ('trabalhador' in referencia) {
            this.filters.trabalhador = referencia;
        }

        this.filterReload();
    }

    refreshFilters(empresa: string = '', estabelecimento: string = '') {
        this.filtersParams = { empresa, estabelecimento };

        const events = ['trabalhador_refresh', 'lotacao_refresh', 'departamento_refresh'];

        events.forEach(event =>
            this.$rootScope.$broadcast(event, this.filtersParams)
        );
    }

	/* INÍCIO - COMBO DE FUNÇÕES PARA HABILITAR AS FUNÇÕES SELECIONAR TODOS E DOWNLOAD EM LOTE */
	checar_todos(): void {
		this.checkToggle = document.getElementById('check_all') as HTMLInputElement;

		if (this.checkToggle.checked) {
			let checked = this.entities.filter((entity: any): boolean => !entity.disableCheckbox);
			this.checkboxPreenchidos = angular.copy(checked);

			if (checked.length !== this.entities.length) {
				this.toaster.pop({
					type: 'info',
					title: 'Atenção!',
					body: 'toaster-html-directive',
					directiveData: { entities: this.entities },
					bodyOutputType: 'directive',
					timeout: 5000
				});
			}
		} else {
			this.checkboxPreenchidos = [];
		}
	}

	temTodosMarcados(): boolean {
		return !!this.entities.length && (this.checkboxPreenchidos.length === this.entities.length);
	}

	naoTemTodosMarcados(): boolean {
		return !!this.checkboxPreenchidos.length && !this.temTodosMarcados();
	}
	/* FIM - COMBO DE FUNÇÕES PARA HABILITAR AS FUNÇÕES SELECIONAR TODOS E DOWNLOAD EM LOTE */

    filterReload(): void {
		this.busy = true;

        if (!this.filters.apuracao) {
            this.entities = [];
            this.busy = false;
            return;
		}

        const constructor = {
            apuracaoponto: this.filters.apuracao.apuracaoponto,
            empresa: this.$rootScope.session.entities.empresa.empresa,
            estabelecimento: ''
        };

        if (this.filters.trabalhador) {
			constructor['trabalhador'] = this.filters.trabalhador.trabalhador;
		}

		if (this.filters.lotacao) {
			constructor['trabalhador_lotacao'] = this.filters.lotacao.lotacao;
		}

        if (this.filters.departamento) {
			constructor['departamento'] = this.filters.departamento.departamento;
		}

        if (this.filters.grupo) {
			constructor['grupo'] = this.filters.grupo.grupo;
		}

		if (this.filters.situacaoColaborador) {
			constructor['trabalhador_status'] = this.filters.situacaoColaborador;
		}

		this.AnalisesPontoService.constructors = constructor;
		this.entities = this.AnalisesPontoService.reload();
    }

	getRowCustomClass(entity: any & { rowcustomclass: string} ): string {
		return entity.rowcustomclass;
	}

	trataDownload(data: any): void {
		let nomeArquivo = '';
        var blob = new Blob([data]);
        let fileURL = (window.URL || window.webkitURL).createObjectURL(blob);
        var a = document.createElement('a');

		let apuracao = '';
		this.apuracoesSelect.forEach((element) => {
			if (apuracao === '' && element.apuracaoponto === this.filters.apuracao?.apuracaoponto) {
				apuracao = element.inicioapuracao + '-a-' + element.terminoapuracao;
			}
		});
		nomeArquivo = 'analises-apuracao-' + apuracao + '.csv';

        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = fileURL;
        a.download = nomeArquivo;
        a.click();
        window.URL.revokeObjectURL(fileURL);
	}

	exportar(): void {
		this.busy = true;
		let objetoExportacao = {
			'apuracaoponto': this.filters.apuracao?.apuracaoponto,
			'trabalhadores': [] as { 'trabalhador': string }[],
		};
		this.checkboxPreenchidos.forEach((element: IAnalisePonto) => {
			objetoExportacao.trabalhadores.push({'trabalhador': element.trabalhador});
		});
		this.AnalisesPontoService.exportar(objetoExportacao);
	}

	valorExiste(valor: any): boolean {
		return valor !== '' && valor !== undefined && valor !== null ? true : false;
	}
}
